import React, { useState } from 'react';
import { Mail, X } from 'lucide-react';

function EmailModal({ onSubmit, onClose }) {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email.trim() && email.includes('@')) {
      onSubmit(email.trim());
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <X size={24} />
        </button>

        <h2>📊 Get Your Full Report</h2>
        <p>Enter your email to receive the complete analysis report</p>

        <form className="email-form" onSubmit={handleSubmit}>
          <div style={{ position: 'relative' }}>
            <Mail 
              size={20} 
              style={{ 
                position: 'absolute', 
                left: '15px', 
                top: '50%', 
                transform: 'translateY(-50%)',
                color: '#999'
              }} 
            />
            <input
              type="email"
              className="email-input"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{ paddingLeft: '45px' }}
            />
          </div>

          <button type="submit" className="submit-btn">
            Continue Analysis
          </button>

          <p className="privacy-note">
            🔒 Your email is safe with us. We'll never share it.
          </p>
        </form>
      </div>
    </div>
  );
}

export default EmailModal;
